import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {useIntl} from 'react-intl'
import Swal from 'sweetalert2'
import {downloadAcceptanceLetterAsStudent} from '../applicationuser/list/core/_requests'

const API_URL_REAL = process.env.REACT_APP_API_URL

interface PlacementResult {
  code: string
  program: string
  obysStudentNumber: string
  obysPassword: string
  preferencePeriodName: string
  message: string
  name: string
}

const PlacementPage = (): React.ReactElement | null => {
  const [placementResult, setPlacementResult] = useState<PlacementResult | null>(null)
  const [loading, setLoading] = useState(true)
  const [isDownloadingEbys, setIsDownloadingEbys] = useState(false)

  const intl = useIntl()

  useEffect(() => {
    axios
      .get<PlacementResult>(`${API_URL_REAL}/Custom/GetPlacementResult`)
      .then((response) => {
        setPlacementResult(response.data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return <p>Loading...</p>
  }

  if (placementResult?.code === '0' || placementResult?.code === '2') {
    return (
      <div className='alert alert-danger'>{intl.formatMessage({id: placementResult?.message})}</div>
    )
  }

  if (!placementResult) {
    return (
      <div className='alert alert-danger'>
        {intl.formatMessage({id: 'There is a problem with your request. Please try again later.'})}
      </div>
    )
  }

  //   const handleDownloadEbys = async () => {
  //     try {
  //       setIsDownloadingEbys(true)

  //       const blobData = await downloadAcceptanceLetterAsStudent()

  //       // Backend hata döndüyse Blob içerisindeki JSON'u oku
  //       if (blobData.type === 'application/json') {
  //         const errorText = await blobData.text()
  //         const errorJson = JSON.parse(errorText)

  //         throw new Error(errorJson.message ?? errorJson.Message ?? 'Belge indirilirken hata oluştu.')
  //       }

  //       const blob = new Blob([blobData], {type: 'application/pdf'})
  //       const url = window.URL.createObjectURL(blob)

  //       const link = document.createElement('a')
  //       link.href = url
  //       link.download = 'EBYS_Kabul_Mektubu.pdf'

  //       document.body.appendChild(link)
  //       link.click()

  //       link.remove()
  //       window.URL.revokeObjectURL(url)

  //       Swal.fire({
  //         icon: 'success',
  //         title: 'Başarılı!',
  //         text: 'EBYS Belgesi başarıyla indirildi.',
  //         confirmButtonText: 'Tamam',
  //         customClass: {
  //           confirmButton: 'btn btn-success',
  //         },
  //       })
  //     } catch (error: any) {
  //       console.error(error)

  //       let errorMessage = 'Belge indirilirken beklenmeyen bir hata oluştu.'

  //       if (error.response?.data instanceof Blob) {
  //         try {
  //           const errorText = await error.response.data.text()
  //           const errorJson = JSON.parse(errorText)
  //           errorMessage = errorJson.message ?? errorJson.Message ?? errorText
  //         } catch {
  //           errorMessage = 'Hata mesajı çözümlenemedi.'
  //         }
  //       } else if (error.message) {
  //         errorMessage = error.message
  //       }

  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Hata Oluştu!',
  //         text: errorMessage,
  //         confirmButtonText: 'Tamam',
  //         customClass: {
  //           confirmButton: 'btn btn-danger',
  //         },
  //       })
  //     } finally {
  //       setIsDownloadingEbys(false)
  //     }
  //   }

  return (
    <div>
      <h1>
        {intl.formatMessage({id: 'Dear'})} {placementResult.name}
      </h1>
      <h2>
        {intl.formatMessage({id: 'Placement Results for'})}: {placementResult.preferencePeriodName}
      </h2>

      <div className='card mb-3'>
        <div className='card-body'>
          <h5 className='card-title'>
            {intl.formatMessage({id: 'You have been placed in the program'})}:{' '}
            {placementResult.program}
          </h5>
          <p className='card-text'>
            <strong>{intl.formatMessage({id: 'OBYS Student Number'})}:</strong>{' '}
            {placementResult.obysStudentNumber}
          </p>
          <p className='card-text'>
            <strong>{intl.formatMessage({id: 'OBYS Password'})}:</strong>{' '}
            {placementResult.obysPassword}
          </p>
        </div>
      </div>

      <div className='alert alert-info'>
        {intl.formatMessage({id: 'Note'})}:{' '}
        {intl.formatMessage({
          id: 'Use the OBYS Student Number and OBYS Password provided above for your initial registration.',
        })}
      </div>

      {/* <div className='mt-4'>
        <button
          className='btn btn-primary'
          onClick={handleDownloadEbys}
          disabled={isDownloadingEbys}
        >
          {isDownloadingEbys ? (
            <>
              <span className='spinner-border spinner-border-sm me-2'></span>
              Belge İndiriliyor...
            </>
          ) : (
            'Kabul Mektubu İndir'
          )}
        </button>
      </div> */}
    </div>
  )
}

export default PlacementPage
